import { PencilIcon } from "@icons";
import { IconButton, Tooltip } from "@common";

interface PayorAllocationCardProps {
    name: string;
    column1: React.ReactNode;
    column2: React.ReactNode;
    column3: React.ReactNode;
    showEditButton?: boolean;
    editButtonTooltip: string;
    onEdit?: () => void;
    editButtonDisabled: boolean;
}

const PayorAllocationCard: React.FC<PayorAllocationCardProps> = ({
    name,
    column1,
    column2,
    column3,
    showEditButton = true,
    editButtonTooltip,
    onEdit,
    editButtonDisabled
}) => (
    <div className="bg-white border border-neutral-200 rounded-xl p-4 flex gap-6 items-center">
        {/* Content */}
        <div className="flex-1 flex flex-col gap-1">
            <h3 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.16px] overflow-hidden text-ellipsis whitespace-nowrap">
                {name}
            </h3>
            <div className="flex gap-4 text-sm leading-5 tracking-[0.14px]">
                <div className="flex-1">{column1}</div>
                <div className="flex-1">{column2}</div>
                <div className="flex-1">{column3}</div>
            </div>
        </div>

        {/* Actions */}
        <div className="flex items-start">
            {showEditButton ? (
                <Tooltip
                    content={editButtonTooltip}
                    position="top"
                >
                    <IconButton
                        variant="secondary"
                        size="lg"
                        disabled={editButtonDisabled}
                        onClick={onEdit}
                        aria-label="Edit payor"
                    >
                        <PencilIcon className="w-5 h-5 text-neutral-900" />
                    </IconButton>
                </Tooltip>
            ) : (
                <div className="w-8 h-8" />
            )}
        </div>
    </div>
);

export default PayorAllocationCard;
